import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from "../utils/domain/accessControl";
import { Permission } from "./permissions";
import { FeatureToggle } from "./featureToggles";

export const externalHealthDashboardAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.externalHealthDashboardFeatureToggles],
  minICPlatformVersion: ICPlatformVersion.r2025_11_0,
  permissions: [Permission.ExternalHealthDashboard],
};
